<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div v-if="isConfig && !isDisabled && isCancelClick">
      <div class="grid active line-text mt-3">
        <div class="col-12 lg:col-7">
          <label for="dealname" class="control-label">
            {{
            lmodel.setDealName
            }}
          </label>
        </div>
        <div class="col-12 lg:col-5">
          <InputRequiredText
            v-model="vmodel1.setName"
            :validation="valmodel.setName"
            id="dealName"
            class="mt-1"
            :PropName="lmodel.setDealName"
          ></InputRequiredText>
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid active line-text mt-3">
        <div class="col-12 lg:col-7">
          <label for="Site" class="control-label">
            {{
            staticData.configuration.site
            }}
          </label>
        </div>
        <div class="col-12 lg:col-5">
          <DropDownRequire
            v-model="vmodel1.setSiteId"
            :options="dmodel.settings.siteList"
            :validation="valmodel.setSiteId"
            PropName="Site"
            id="SiteId"
            :placeholder="lmodel.setSelectSitePlaceholder"
            optionLabel="text"
            optionValue="value"
            class="w-full mt-1"
            @update:modelValue="handleSiteChangeEvent"
            editable
          ></DropDownRequire>
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for="Language" class="control-label">{{ staticData.configuration.language }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <DropDownRequire
            v-model="vmodel1.setLanguage"
            :validation="valmodel.setLanguage"
            :options="dmodel.settings.languageList"
            PropName="Deal Language"
            id="Language"
            :placeholder="lmodel.setDealLanguagePlaceholder"
            optionLabel="text"
            optionValue="value"
            class="mt-1"
            @update:modelValue="GetDynamicConsents"
            editable
          ></DropDownRequire>
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for="Tag Name" class="control-label">{{ staticData.configuration.tagname }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <InputText
            v-model="vmodel1.setTagName"
            id="tagName"
            type="text"
            autocomplete="off"
            style="text-transform: lowercase"
            class="mt-1"
          />
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for="Language" class="control-label">{{ staticData.configuration.dealtargetpage }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <InputText
            v-model="vmodel1.setTargetCampaignURL"
            id="TargetCampaignURL"
            PropName="Target Campaign URL"
            class="mt-1"
            :placeholder="lmodel.setTargetPageUrlPlaceholder"
          ></InputText>
        </div>
      </div>

      <div
        class="grid line-text mt-1"
        v-if="
          vmodel.setGeneratedShortenURL !== '' &&
          vmodel.setGeneratedShortenURL !== null
        "
      >
        <div class="col-12 lg:col-7" style="display: flex; align-items: center">
          <label for="generateddealurl" class="control-label">
            {{
            staticData.configuration.generateddealurl
            }}
          </label>
          <div class="copytooltip">
            <i
              class="fa fa-copy ml-3"
              v-clipboard:copy="vmodel.setGeneratedShortenURL"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              v-on:mouseover="copySucceeded = null"
            ></i>

            <span
              class="tooltiptext"
              id="TooltipTextSpan"
              v-if="copySucceeded == null"
            >{{ staticData.updatedeal.settings.copy_url }}</span>

            <span class="tooltiptext" id="TooltipTextSpan" v-if="copySucceeded == true">
              {{ staticData.updatedeal.settings.copied_url
              }}{{ vmodel.setGeneratedShortenURL }}
            </span>
            <span
              class="tooltiptext"
              id="TooltipTextSpan"
              v-if="copySucceeded == false"
            >{{ staticData.updatedeal.settings.copy_fail }}</span>
          </div>
          <span>
            <i
              class="fa fa-qrcode ml-3"
              @click="visible = true"
              style="margin-left: 20px; font-size: 21px; cursor: pointer"
            ></i>
          </span>
        </div>

        <div class="col-12 lg:col-5">
          <InputText
            v-model="vmodel1.setGeneratedShortenURL"
            id="setGeneratedShortenURL"
            disabled="disabled"
            readonly
            class="mt-1"
          />
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for="ambattrtime" class="control-label">{{ staticData.configuration.ambattrtime }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <InputRequiredNumber
            :validation="valmodel.ambConversionDays"
            v-model="vmodel1.ambConversionDays"
            id="conversionDays"
            PropName="Conversion no of days"
            :placeholder="lmodel.ambConversionDaysPlaceholder"
            MinValue="0"
            MaxValue="100"
            class="mt-2"
          ></InputRequiredNumber>
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for class="control-label">{{ staticData.configuration.ambreferralsession }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <InputRequiredNumber
            :validation="valmodel.ambreferralSessionBlockTime"
            v-model="vmodel1.ambreferralSessionBlockTime"
            id="ambReferralSessionBlockTime"
            PropName="Referral Session Block Time"
            MinValue="0"
            MaxValue="365"
            class="mt-2"
          ></InputRequiredNumber>
        </div>
      </div>
      <div class="border-line mt-2"></div>

      <div class="grid line-text mt-1">
        <div class="col-12 lg:col-7">
          <label for class="control-label">{{ staticData.configuration.settingpreset }}</label>
        </div>
        <div class="col-12 lg:col-5">
          <DropDownRequire
            v-model="vmodel1.setloadingPreset"
            :options="dmodel.settings.presetList"
            PropName="Load-Settings-Present"
            id="loadSettingspresentId"
            optionLabel="text"
            optionValue="value"
            class="mt-1"
            editable
          ></DropDownRequire>
        </div>
      </div>
      <div class="border-line mt-3"></div>
      <!-- done -->

      <div class="grid mt-1">
        <div class="col-12 lg:col-6 custom-settings line-text">
          <div id="custom-settings" class="custom-settings-button">
            <div class="toggle-button">
              <ToggleButton
                v-model="showCustomSetting"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <span
                class="ml-1 custom-setting-text"
              >{{ staticData.configuration.ambcustomsettings }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- General Settings start-->
      <div class="grid mt-2 line-text" v-if="showCustomSetting">
        <div class="col-12 lg:col-7">
          <span class="general-settings-text">{{ staticData.configuration.gensettings }}</span>
        </div>

        <div class="col-12 lg:col-5" v-if="!vmodel1.ambNeverDisplay">
          <Checkbox
            :binary="true"
            v-model="vmodel1.ambAllowexistingmember"
            id="allowexistingmember"
            type="checkbox"
            class="deal-form-subgroup custom-control-input"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="allowexistingmember"
            class="ml-2 checkbox-radio-font"
            id="allowexistingmember-tooltip"
            v-tooltip="lmodel.ambAllowExistingMemberToolTip"
          >{{ lmodel.ambAllowExistingMember }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="enbusersrwd"
            id="enbusersrwd"
            type="checkbox"
            class="deal-form-subgroup custom-control-input"
            @change="handleToChange"
          />
          <label
            for="allowexistingmember"
            class="ml-2 checkbox-radio-font"
            id="enbuserssamerwd"
          >{{ staticData.configuration.enbuserssamerwd }}</label>
        </div>
        <!-- <span > requires contact integration </span> -->
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="vmodel1.setisCollectCPOEmailPhone"
            id="isCollectCPOEmailPhone"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="isCollectCPOEmailPhone"
            class="ml-2 checkbox-radio-font"
            id="isCollectCPOEmailPhone-tooltip"
            v-tooltip="lmodel?.setIsCollectCPOEmailPhoneToolTip"
          >{{ lmodel.setIsCollectCPOEmailPhone }}</label>
        </div>
      </div>

      <div class="border-line mt-3" v-if="showCustomSetting"></div>

      <!-- General Settings end -->

      <!-- Widget display settings Start -->
      <div class="grid mt-2 line-text" v-if="showCustomSetting">
        <div class="col-12 lg:col-7">
          <span class="general-settings-text">{{ staticData.configuration.wdgtdisplay }}</span>
        </div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            id="ambNeverDisplay"
            v-model="vmodel1.ambNeverDisplay"
            type="checkbox"
            @change="handleToChange"
          />
          <label
            for="ambNeverDisplay"
            class="ml-2 checkbox-radio-font"
            id="ambNeverDisplay-tooltip"
            v-tooltip="lmodel.ambNeverDisplayToolTip"
          >{{ lmodel.ambNeverDisplay }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            id="ambshowinfomis"
            v-model="vmodel1.ambShowinfomis"
            type="checkbox"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="ambshowinfomis"
            class="ml-2 checkbox-radio-font"
            id="ambshowinfomis-tooltip"
          >{{ lmodel.ambDisplayOnlyMissInfo }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5" v-if="!vmodel1.ambNeverDisplay">
          <Checkbox
            :binary="true"
            v-model="displayrwd"
            id="displayrwd"
            type="checkbox"
            class="deal-form-subgroup custom-control-input"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="displayrwd"
            class="ml-2 checkbox-radio-font"
            id="displayrwd-tooltip"
          >{{ staticData.configuration.displayrwd }}</label>
        </div>
      </div>
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="vmodel1.ambOpenAsMinimized"
            id="openAsMinimized"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="openAsMinimized"
            class="ml-2 checkbox-radio-font"
            id="openAsMinimized-tooltip"
            v-tooltip="lmodel.ambOpenAsMinimizedToolTip"
          >{{ lmodel.ambOpenAsMinimized }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            id="ndmw"
            v-model="vmodel1.ambndmw"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="ndmw"
            class="ml-2 checkbox-radio-font"
            id="ambNeverDisplay-tooltip"
            v-tooltip="lmodel.ambNeverDisplayToolTip"
          >{{ lmodel.ambNeverDisplayMinWidget }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="vmodel1.ambHintButMaskCode"
            id="hintButMaskCode"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="hintButMaskCode"
            class="ml-2 checkbox-radio-font"
            id="hintButMaskCode-tooltip"
            v-tooltip="lmodel.ambHintButMaskCodeToolTip"
          >{{ lmodel.ambHintButMaskCode }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            id="allowMinimizeOnLastStep"
            v-model="vmodel1.amballowMinimizeOnLastStep"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="allowMinimizeOnLastStep"
            class="ml-2 checkbox-radio-font"
            id="allowMinimizeOnLastStep-tooltip"
          >{{ lmodel.ambAllowMinimizeOnLastStep }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <label-tooltip
            :labelvalue="lmodel.ambYourCodeWillShowHereText"
            :tooltipvalue="lmodel.ambYourCodeWillShowHereTextToolTip"
            tooltipvalueFor="ambYourCodeWillShowHereText-tooltip"
            labelclass="control-label"
            :isRequiredLabel="false"
          ></label-tooltip>
          <InputText
            v-model="vmodel1.ambYourCodeWillShowHereText"
            id="ambYourCodeWillShowHereText"
            type="text"
            :placeholder="lmodel.ambYourCodeWillShowHereTextPlaceholder"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="border-line mt-3" v-if="showCustomSetting"></div>

      <!-- Widget display settings End -->
      <!-- Email Settings Start -->
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7">
          <span class="general-settings-text">{{ staticData.configuration.emailsettings }}</span>
        </div>
        <div class="grid col-12 lg:col-5">
          <div>
            <div id="custom-settings">
              <div class="toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambEnableAmbassadorMails"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on': enbambcodemail,
                    'toggle-off': !enbambcodemail,
                  }"
                  @click="toggleEmailSettings"
                ></span>-->

                <span class="ml-1">{{ staticData.configuration.enbambemail }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="vmodel1.ambReqEmailVer"
            id="ambReqEmailVer"
            type="checkbox"
            @change="handleToChange"
            :disabled="vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'"
          />
          <label
            for="ambReqEmailVer"
            class="ml-2 checkbox-radio-font"
            id="ambReqEmailVer-tooltip"
          >{{ lmodel.ambReqEmailVer }}</label>
        </div>
      </div>
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5">
          <Checkbox
            :binary="true"
            v-model="vmodel1.setIsSendReminderAlways"
            id="IsSendReminderAlways"
            @change="handleToChange"
            type="checkbox"
            :disabled="
              vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests' &&
              !enableAmbassadorMails
            "
          />
          <label
            for="IsSendReminderAlways"
            class="ml-2 checkbox-radio-font"
            id="reminderWithoutOptIn-tooltip"
            v-tooltip="lmodel.setReminderWithoutOptInToolTip"
          >{{ lmodel.setReminderWithoutOptIn }}</label>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7"></div>

        <div class="grid col-12 lg:col-5">
          <div>
            <div id="custom-settings">
              <div class="toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambEmailReminder"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on': enbambremindermails,
                    'toggle-off': !enbambremindermails,
                  }"
                  @click="emailReminderCall"
                ></span>-->
                <span class="ml-1">{{ staticData.configuration.enbambreminder }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-line mt-3" v-if="showCustomSetting && !vmodel1.ambNeverDisplay"></div>
      <!-- Email Settings End -->
      <!-- Referral settings start-->
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-7">
          <span class="general-settings-text">{{ staticData.configuration.ambreferralsetting }}</span>
        </div>
        <div class="grid col-12 lg:col-5">
          <div>
            <div id="custom-settings">
              <div class="toggle-button toggleblock-btn">
                <ToggleButton
                  v-model="vmodel1.ambDisablereferrals"
                  onIcon="toggle-on"
                  offIcon="toggle-off"
                  class="toggle-btn"
                />
                <!-- <span
                  :class="{
                    'toggle-on': referrals,
                    'toggle-off': !referrals,
                  }"
                  @click="referrals = !referrals"
                ></span>-->
                <span class="ml-2">{{ staticData.configuration.ambreferrals }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="referrals">
        <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <Checkbox
              :binary="true"
              id="frndlinkexpires"
              v-model="vmodel1.ambfrndlnkexp"
              type="checkbox"
              @change="handleToChange"
              :disabled="
                vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'
              "
            />
            <label
              for="frndlinkexpires"
              class="ml-2 checkbox-radio-font"
              id="frndlinkexpires-tooltip"
            >{{ lmodel.ambFriendLinkExpire }}</label>
          </div>
        </div>
        <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <Checkbox
              :binary="true"
              id="EnbSepUTMDealSetting"
              type="checkbox"
              @change="handleToChange"
              v-model="vmodel1.setEnableUTMTags"
              :disabled="
                vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'
              "
            />
            <label
              for="EnbSepUTMDealSetting"
              class="ml-2 checkbox-radio-font"
              id="EnbSepUTMDealSetting-tooltip"
              v-tooltip="lmodel.setEnableUTMTagsToolTip"
            >{{ lmodel.setEnableUTMTags }}</label>
          </div>
        </div>
        <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <Checkbox
              :binary="true"
              v-model="vmodel1.ambDisFriendFlow"
              id="ambassadorDisableFriendFlow"
              type="checkbox"
              @change="handleToChange"
              :disabled="
                vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'
              "
            />
            <label
              for="ambassadorDisableFriendFlow"
              class="ml-2 checkbox-radio-font"
              id="ambassadorDisableFriendFlow-tooltip"
              v-tooltip="lmodel.ambassadorDisableFriendFlowToolTip"
            >{{ lmodel.ambassadorDisableFriendFlow }}</label>
          </div>
        </div>

        <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <Checkbox
              :binary="true"
              id="AnimateChnsectionDealSetting"
              type="checkbox"
              v-model="vmodel1.setAnimateDealSetting"
              @change="handleToChange"
              :disabled="
                vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'
              "
            />
            <label
              for="AnimateChnsectionDealSetting"
              class="ml-2 checkbox-radio-font"
              id="animateChnsectionDealSetting-tooltip"
              v-tooltip="lmodel.setAnimateDealSettingToolTip"
            >{{ lmodel.setAnimateDealSetting }}</label>
          </div>
        </div>

        <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <Checkbox
              :binary="true"
              v-model="vmodel1.setAmbassadorInfoInFriendLink"
              id="ambassadorInfoInFriendLink"
              type="checkbox"
              @change="handleToChange"
              :disabled="
                vmodel1.setloadingPreset == 'EmptyCompaignsForLiftTests'
              "
            />
            <label
              for="ambassadorInfoInFriendLink"
              class="ml-2 checkbox-radio-font"
              id="ambassadorInfoInFriendLink-tooltip"
              v-tooltip="lmodel.setAmbassadorInfoInFriendLinkToolTip"
            >{{ lmodel.setAmbassadorInfoInFriendLink }}</label>
          </div>
        </div>
      </div>
      <div class="border-line mt-3" v-if="showCustomSetting && !vmodel1.ambNeverDisplay"></div>

      <!-- Referral settings End-->
      <!-- Redirect Page -->
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-12">
          <span class="general-settings-text">{{ staticData.configuration.redirect_page }}</span>
        </div>
        <div class="col-12 lg:col-6 py-0">
          <label
            class="control-label"
            v-tooltip="lmodel.setRedirecttxtToolTip"
            for="redirecttxt-tooltip"
            :isRequiredLabel="false"
          >{{ lmodel.setRedirecttxt }}</label>
          <InputText
            v-model="vmodel1.setRedirecttxt"
            id="redirectText"
            type="text"
            autocomplete="off"
          />
        </div>
        <div class="col-12 lg:col-6 py-0">
          <label
            class="control-label"
            v-tooltip="lmodel.setRedirectbtntxtToolTip"
            for="redirecttxt-tooltip"
            :isRequiredLabel="false"
          >{{ lmodel.setRedirectbtntxt }}</label>
          <InputText
            v-model="vmodel1.setRedirectbtntxt"
            id="redirectText"
            class="mt-0"
            type="text"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="border-line mt-3" v-if="showCustomSetting && !vmodel1.ambNeverDisplay"></div>
      <!-- Redirect Page End -->
      <!-- Setting -->
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-12">
          <span class="general-settings-text">{{ staticData.configuration.settingsField }}</span>
        </div>

        <div class="col-12 lg:col-6 py-0">
          <label
            class="control-label"
            v-tooltip="lmodel.ambDealTagAfterCompletionToolTip"
            for="ambDealTagAfterCompletion-tooltip"
            :isRequired="false"
          >{{ lmodel.ambPriority }}</label>
          <InputRequiredNumber
            :validation="valmodel.ambPriority"
            v-model="vmodel1.ambPriority"
            type="text"
            autocomplete="off"
            class="mt-1"
            id="priority"
            :PropName="lmodel.ambPriority"
            maxlength="30"
          />
        </div>

        <div class="col-12 lg:col-6 py-0">
          <label
            class="control-label"
            v-tooltip="lmodel.ambDealTagAfterCompletionToolTip"
            for="ambDealTagAfterCompletion-tooltip"
            :isRequired="false"
          >{{ lmodel.ambDealTagAfterCompletion }}</label>
          <InputText
            v-model="vmodel1.ambassadorDealTagAfterCompletion"
            type="text"
            autocomplete="off"
            :placeholder="lmodel.ambDealTagAfterCompletionPlaceholder"
            id="AmbassadorDealTagAfterCompletion"
            maxlength="30"
            @input="
              if (!vmodel.ambassadorDealTagAfterCompletion) {
                vmodel1.ambOpenDealbytagFornewmember = false;
              }
            "
          />
        </div>

        <div class="col-12 lg:col-6">
          <label
            class="control-label"
            v-tooltip="lmodel.ambRUARToolTip"
            for="ambRUAR-tooltip"
            :isRequiredLabel="false"
          >{{ lmodel.ambRUAR }}</label>
          <InputRequiredText
            v-model="vmodel1.ambRUAR"
            :validation="valmodel.ambRUAR"
            :IsLandingURL="true"
            PropName="Redirect URL"
            id="ambRUAR"
            type="text"
            :placeholder="lmodel.ambRUARPlaceholder"
            autocomplete="off"
          ></InputRequiredText>
        </div>
        <div class="col-12 lg:col-6">
          <label
            class="control-label"
            v-tooltip="lmodel.openDealTagForExistingMemberToolTip"
            for="ambRUAR-tooltip"
            :isRequiredLabel="false"
          >{{ lmodel.ambOpenDealTagForExistingMember }}</label>
          <InputRequiredText
            v-model="vmodel1.ambopenDealTagForExistingMember"
            id="ambRUAR"
            type="text"
            :placeholder="lmodel.ambRUARPlaceholder"
            autocomplete="off"
          ></InputRequiredText>
        </div>
      </div>
      <div class="border-line mt-3" v-if="showCustomSetting && !vmodel1.ambNeverDisplay"></div>
      <!-- Settings End -->

      <!-- NPS settings start -->
      <div class="grid mt-2 line-text" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
        <div class="col-12 lg:col-12">
          <span class="general-settings-text">{{ staticData.updatedeal.settings.nps_settings }}</span>
        </div>
        <div class="col-12 lg:col-6" v-if="showCustomSetting && !vmodel1.ambNeverDisplay">
          <label
            v-tooltip="lmodel.ambNpsTypeToolTip"
            tooltipvalueFor="ambNpsType"
            labelclass="control-label"
            :isRequiredLabel="false"
          >{{lmodel.ambNpsType}}</label>
          <Dropdown
            v-model="vmodel1.ambNPSType"
            :options="dmodel.ambassadorFriend.npsType"
            id="ambNPSType"
            class="mt-2 w-full"
            optionLabel="text"
            optionValue="value"
            editable
          ></Dropdown>
        </div>
        <div class="col-12 lg:col-6" v-if="showCustomSetting && !vmodel1.ambNeverDisplay"></div>
        <div
          class="col-12 lg:col-12"
          v-show="
              vmodel.ambNPSType !== 'DisabledNPS' &&
              showCustomSetting &&
              !vmodel1.ambNeverDisplay
          "
        >
          <label
            v-tooltip="lmodel.ambNpsTitleToolTip"
            tooltipvalueFor="npsTitle"
            labelclass="control-label"
          >{{lmodel.ambNpsTitle}}</label>
          <Textarea
            v-model="vmodel1.ambNPSTitle"
            type="text"
            autocomplete="off"
            :placeholder="lmodel.ambNpsTitlePlaceholder"
            class="mt-1"
            id="npsTitle"
          ></Textarea>
        </div>

        <div
          class="col-12 lg:col-12"
          v-show="
            vmodel.ambNPSType !== 'DisabledNPS' &&
            showCustomSetting &&
            !vmodel1.ambNeverDisplay
          "
        >
          <label
            v-tooltip="lmodel.ambNpsMessageToolTip"
            tooltipvalueFor="npsMessage"
            labelclass="control-label"
          >{{lmodel.ambNpsMessage}}</label>
          <Textarea
            v-model="vmodel1.ambNPSMessage"
            type="text"
            autocomplete="off"
            :placeholder="lmodel.ambNpsMessagePlaceholder"
            class="mt-1"
            id="npsMessage"
          ></Textarea>
        </div>
      </div>

      <!-- NPS settings end -->

      <div
        :class="
          !isDisabled
            ? 'header-edit-mode text-right button-container'
            : 'head-mode text-right button-container'
        "
      >
        <PrimeButton
          id="cancelbtn"
          type="button"
          name="Cancel"
          value="cancel"
          label="Cancel"
          @click="cancelBtn()"
          class="cancel-btn"
        />
        <PrimeButton label="Save" class="save-btn1 ml-2 mr-2" icon="save-icon" @click="saveData"></PrimeButton>
      </div>
    </div>

    <!-- if u need to show save data without close just put || isSave below -->
    <div v-if="(isDisabled && isConfig) || (isSave && !isConfig)">
      <div class="grid line-text">
        <div class="col-3">
          <label for="siteid" class="control-label1">{{ lmodel.setDealName }}</label>
        </div>
        <div class="col-9">
          <label for="siteval" class="control-label">{{ vmodel1.setName }}</label>
        </div>
      </div>

      <div class="grid line-text">
        <div class="col-3">
          <label for="siteid" class="control-label1">{{ staticData.configuration.site }}</label>
        </div>
        <div class="col-9">
          <label for="siteval" class="control-label">{{ vmodel1.setSiteId }}</label>
        </div>
      </div>
      <div class="grid line-text">
        <div class="col-3">
          <label for="languageid" class="control-label1">{{ staticData.configuration.language }}</label>
        </div>
        <div class="col-9">
          <label for="languageval" class="control-label">{{ vmodel1.setLanguage }}</label>
        </div>
      </div>

      <div class="grid line-text">
        <div class="col-3">
          <label for="tagnameid" class="control-label1">{{ staticData.configuration.tagname }}</label>
        </div>
        <div class="col-9">
          <label for="tagnameval" class="control-label">{{ vmodel1.setTagName }}</label>
        </div>
      </div>

      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label
            for="dealtargetpageid"
            class="control-label1"
          >{{ staticData.configuration.dealtargetpage }}</label>
        </div>
        <div class="col-12 lg:col-9">
          <label for="dealurlid" class="control-label">{{ vmodel1.setTargetCampaignURL }}</label>
        </div>
      </div>

      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="attrdays" class="control-label1">{{ staticData.configuration.ambattrtime }}</label>
        </div>
        <div class="col-12 lg:col-9">
          <label for="attrdaysval" class="control-label">{{ vmodel1.ambConversionDays }}</label>
        </div>
      </div>

      <div class="grid line-text-2">
        <div class="col-12 lg:col-4">
          <PrimeButton class="show-all" @click="toggleShowData()" style="justify-content: center">
            <span>{{ showAll ? "Show less" : "Show all" }}</span>
            <i class="pi pi-angle-right"></i>
          </PrimeButton>
        </div>
      </div>
      <div class="grid line-text" v-if="showAll">
        <div class="col-12 lg:col-3">
          <label
            for="referralsessionid"
            class="control-label1"
          >{{ staticData.configuration.ambreferralsession }}</label>
        </div>
        <div class="col-12 lg:col-9">
          <label
            for="referralsessionval"
            class="control-label1"
          >{{ vmodel1.ambreferralSessionBlockTime }}</label>
        </div>
      </div>
      <div class="grid line-text" v-if="showAll">
        <div class="col-12 lg:col-3">
          <label
            for="settingpresetid"
            class="control-label1"
          >{{ staticData.configuration.settingpreset }}</label>
        </div>
        <div class="col-12 lg:col-9">
          <label for="settingpresetval" class="control-label">{{ vmodel1.setloadingPreset }}</label>
        </div>
      </div>
      <div class="grid col-12 lg:col-6 line-text" v-if="showAll">
        <label id="custom-settings">
          <div class="toggle-button">
            <span
              :class="{
                'toggle-on': showCustomSetting,
                'toggle-off': !showCustomSetting,
              }"
              @click="showCustomSetting = !showCustomSetting"
            ></span>
            <span class="ml-1 custom-setting-text">{{ staticData.configuration.ambcustomsettings }}</span>
          </div>
        </label>
      </div>

      <div class="grid mt-2 line-text" v-if="showCustomSetting && showAll">
        <div class="col-12 lg:col-3">
          <span class="general-settings-text">{{ staticData.configuration.gensettings }}</span>
        </div>
        <div class="col-12 lg:col-9" v-if="!vmodel1.ambNeverDisplay">
          <Checkbox
            :binary="true"
            v-model="vmodel1.allowexistingmember"
            id="allowexistingmember"
            type="checkbox"
            class="deal-form-subgroup custom-control-input"
            @change="handleToChange"
            :disabled="true"
          />
          <label
            for="allowexistingmember"
            class="ml-2 checkbox-radio-font"
            id="allowexistingmember-tooltip"
            v-tooltip="lmodel.ambAllowExistingMemberToolTip"
          >{{ lmodel.ambAllowExistingMember }}</label>
        </div>
      </div>

      <div
        class="grid mt-2 line-text"
        v-if="showCustomSetting && !vmodel1.ambNeverDisplay && showAll"
      >
        <div class="col-12 lg:col-3">
          <span class="general-settings-text">{{ staticData.configuration.wdgtdisplay }}</span>
        </div>
        <div class="col-12 lg:col-9">
          <Checkbox
            :binary="true"
            v-model="displayrwd"
            id="displayrwd"
            type="checkbox"
            class="deal-form-subgroup custom-control-input"
            @change="handleToChange"
            :disabled="true"
          />
          <label
            for="displayrwd"
            class="ml-2 checkbox-radio-font"
            id="displayrwd-tooltip"
          >{{ staticData.configuration.displayrwd }}</label>
        </div>
      </div>
      <div
        class="grid mt-2 line-text"
        v-if="showCustomSetting && !vmodel1.ambNeverDisplay && showAll"
      >
        <div class="col-12 lg:col-3">
          <span class="general-settings-text">{{ staticData.configuration.emailsettings }}</span>
        </div>
        <div class="col-12 lg:col-9">
          <label id="custom-settings">
            <div class="toggle-button toggleblock-btn">
              <span
                :class="{
                  'toggle-on': enbambcodemail,
                  'toggle-off': !enbambcodemail,
                }"
                @click="enbambcodemail = !enbambcodemail"
              ></span>
              <span class="ml-1">{{ staticData.configuration.enbambemail }}</span>
            </div>
          </label>
        </div>
      </div>
      <div
        class="grid mt-2 line-text-2"
        v-if="showCustomSetting && !vmodel1.ambNeverDisplay && showAll"
      >
        <div class="col-12 lg:col-3">
          <span class="general-settings-text">{{ staticData.configuration.ambreferralsetting }}</span>
        </div>
        <div class="col-12 lg:col-9">
          <label id="custom-settings">
            <div class="toggle-button toggleblock-btn">
              <span
                :class="{
                  'toggle-on': referrals,
                  'toggle-off': !referrals,
                }"
                @click="referrals = !referrals"
              ></span>
              <span class="ml-2">{{ staticData.configuration.ambreferrals }}</span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
  <Dialog
    v-model:visible="visible"
    modal
    header="Scan QR Code"
    position="top "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '30vw' }"
  >
    <qr-code :text="vmodel1.setGeneratedShortenURL" style="display: flex; justify-content: center"></qr-code>
  </Dialog>
  <Dialog
    v-model:visible="visible"
    modal
    header="Scan QR Code"
    position="top "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '30vw' }"
  >
    <qr-code :text="vmodel1.setGeneratedShortenURL" style="display: flex; justify-content: center"></qr-code>
  </Dialog>
</template>

<script>
import LabelTooltip from "@/components/shared/label-tooltip.vue";
import DataLayerService from "@/services/data-layer.service";
import moment from "moment";
import staticData from "@/staticdata/static.json";
import Dialog from "primevue/dialog";

export default {
  components: {
    "label-tooltip": LabelTooltip,
    Dialog
  },
  props: {
    dealId: {
      type: String,
      default: null
    },
    tabId: {
      type: Number,
      default: 0
    },
    lmodel: {
      type: Object,
      default: null
    },
    dmodel: {
      type: Object,
      default: null
    },
    vmodel: {
      type: Object,
      default: null
    },
    valmodel: {
      type: Object,
      default: null
    },
    dealStatus: {
      type: Number,
      default: null
    },
    isRedealText: {
      type: Boolean,
      default: false
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false
    },
    modelstate: {
      type: Object,
      default: null
    },
    isConfig: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isCancelClick: {
      type: Boolean,
      default: false
    },
    voyadoDomain: {
      type: String,
      default: ""
    },
    voyadoApi: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      updatedModel: {},
      staticData: staticData,
      showAll: false,
      isSave: false,
      referrals: true,
      enbambremindermails: false,
      enbambcodemail: false,
      displayrwd: true,
      enbusersrwd: true,
      isDealSet: false,
      visible: false,
      errorMessage: true,
      showCustomSetting: false,
      // isCancel: false,
      catchError: "",
      todayDt: moment(),
      copySucceeded: null,
      separatorExp: /,| /,
      id: this.$route.params.id,
      isAdvance: false,
      ShowChangePopup: false,
      targetCampaignURL: "",
      // setGeneratedShortenURL: "",
      showGeneratedURL: false
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },

  watch: {
    "vmodel1.setloadingPreset": function(newVal) {
      if (newVal === "EmptyCompaignsForLiftTests") {
        this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = true;
        this.vmodel1.openAsMinimized = false;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = false;
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.allowexistingmember = false;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = false;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = false;
        this.vmodel1.emailReminder = false;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = false;
        this.vmodel1.disablereferrals = false;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = false;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      } else if (newVal === "SignupCampaignWithRewardAndEmails") {
        this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = true;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = true;
        this.vmodel1.showCodeInPopup = true;
        this.vmodel1.allowexistingmember = false;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = false;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = true;
        this.vmodel1.emailReminder = true;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = true;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      } else if (newVal === "SignupCampaignWithoutRewardAndEmails") {
        this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = true;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = false;
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.allowexistingmember = false;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = false;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = false;
        this.vmodel1.emailReminder = false;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = true;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      } else if (newVal === "ReachAbilityCampaignWithRewardAndEmails") {
        this.vmodel1.tagName = "login";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = false;
        this.vmodel1.showinfomis = true;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = true;
        this.vmodel1.showCodeInPopup = true;
        this.vmodel1.allowexistingmember = true;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = false;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = true;
        this.vmodel1.emailReminder = true;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = true;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      } else if (newVal === "ReachAbilityCampaignWithoutRewardAndEmails") {
        this.vmodel1.tagName = "login";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = false;
        this.vmodel1.showinfomis = true;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = false;
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.allowexistingmember = true;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = false;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = false;
        this.vmodel1.emailReminder = false;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = true;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      }

      // //ONE
      else if (newVal === "OnsitePromotionWithCountdownTimerWithoutReward") {
        this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = true;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = false;
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.allowexistingmember = true;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = true;
        this.vmodel1.allowMinimizeOnLastStep = true;
        this.vmodel1.enableAmbassadorMails = false;
        this.vmodel1.emailReminder = false;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = false;
        this.vmodel1.disablereferrals = true;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = false;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      }
      //       //TWO
      else if (newVal === "ReferralCampaignWithRewardAndEmails") {
        // this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = true;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = true;
        this.vmodel1.showCodeInPopup = true;
        this.vmodel1.allowexistingmember = true;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = true;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = true;
        this.vmodel1.emailReminder = true;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = false;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      }
      //         //THREE
      else if (newVal === "ReferralCampaignWithoutRewardAndEmails") {
        // this.vmodel1.tagName = "cornerwidget";
        this.vmodel1.ambNeverDisplay = false;
        this.vmodel1.openAsMinimized = true;
        this.vmodel1.showinfomis = false;
        this.vmodel1.ndmw = false;
        this.vmodel1.enableDealToCustomer = false;
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.allowexistingmember = true;
        this.vmodel1.hintButMaskCode = false;
        this.vmodel1.allowSameReward = true;
        this.vmodel1.allowMinimizeOnLastStep = false;
        this.vmodel1.enableAmbassadorMails = false;
        this.vmodel1.emailReminder = false;
        this.vmodel1.reqEmailVer = false;
        this.vmodel1.isCollectCPOEmailPhone = false;
        this.vmodel1.isSendReminderAlways = true;
        this.vmodel1.disablereferrals = false;
        this.vmodel1.disFriendFlow = false;
        this.vmodel1.frndlnkexp = false;
        this.vmodel1.animateDealSetting = true;
        this.vmodel1.enableUTMTags = false;
        this.vmodel1InfoInFriendLink = false;
      }
    }
  },
  mounted() {
    this.loadData();

    document.body.style.overflow = "auto";
    const storedURL = localStorage.getItem("setGeneratedShortenURL");
    if (storedURL) {
      this.setGeneratedShortenURL = storedURL;
      this.showGeneratedURL = true;
    }
  },
  emits: ["call", "cancel", "siteChange", "languageChange"],
  methods: {
    loadData() {
      const savedData = localStorage.getItem("configuration");
      if (savedData) {
        this.vmodel1 = JSON.parse(savedData);
      }
    },
    GetDynamicConsents() {
      this.$emit("languageChange");
      // const apiUrl = `/site/getdynamicconsents?apikey=${this.voyadoApi}&domain=${this.voyadoDomain}&language=${this.vmodel1?.settings.language}`;
      // DataLayerService.get(apiUrl).then((result) => {
      //   if (result !== null && result !== undefined && result !== []) {
      //     this.voyadoDynamicConsentsOptions = result;
      //   }
      // });
    },
    handleSiteChangeEvent() {
      if (
        this.vmodel1.setSiteId !== "" &&
        this.vmodel1.setSiteId !== null &&
        this.vmodel1.setSiteId !== undefined &&
        this.dmodel.draftOnSiteDropdownList.siteLanguageMappingList !== [] &&
        this.dmodel.draftOnSiteDropdownList.siteLanguageMappingList !== null &&
        this.dmodel.draftOnSiteDropdownList.siteLanguageMappingList !==
          undefined
      ) {
        this.$emit("siteChange");
        // {
        //   DataLayerService.getById(
        //     "/site/getSiteConfiguration",
        //     this.vmodel1.setSiteId
        //   ).then((result) => {
        //     console.log(result, "Result");
        //     // this.vmodel1.ambassador.showVoyadoPromo = result.success;
        //     // this.vmodel1.friend.showVoyadoPromo = result.success;

        //     // if (
        //     //   result.success === false &&
        //     //   this.vmodel1.ambassador.rewardtype === 2
        //     // ) {
        //     //   this.vmodel1.ambassador.rewardtype = 0;
        //     // }
        //     // if (
        //     //   result.success === false &&
        //     //   this.vmodel1.friend.rewardtype === 2
        //     // ) {
        //     //   this.vmodel1.friend.rewardtype = 0;
        //     // }
        //   });
        // }
        // let filterData =
        //   this.dmodel.draftOnSiteDropdownList.siteLanguageMappingList.filter(
        //     (a) => a.value == this.vmodel1.setSiteId
        //   );
        // if (filterData != null && filterData.length > 0) {
        //   this.vmodel1.setLanguage = filterData[0].text;
        //   this.$emit("languageChange");
        // }
      }
    },

    cancelBtn() {
      this.$emit("cancel");
    },

    saveData() {
      this.isSave = true;
      this.$emit("call");
      localStorage.setItem("configuration", JSON.stringify(this.vmodel1));

      //  if (this.targetCampaignURL) {
      //     // Logic to generate shortened URL; example URL used here
      //     this.setGeneratedShortenURL = 'https://short.url/example';
      //     this.showGeneratedURL = true;

      //     // Save the generated URL to localStorage
      //     localStorage.setItem('setGeneratedShortenURL', this.setGeneratedShortenURL);
      //   }
    },

    toggleShowData() {
      this.showAll = !this.showAll;
    },

    onCopy: function() {
      this.copySucceeded = true;
    },
    onError: function() {
      this.copySucceeded = true;
    },
    handleToChange() {
      //ndmw --WORKED
      if (this.vmodel1.ndmw == true) {
        this.vmodel1.openAsMinimized = false;
      }
      // openAsMinimized --WORKED
      if (this.vmodel1.openAsMinimized == true) {
        this.vmodel1.ndmw = false;
      }
      // enableDealToCustomer
      if (this.vmodel1.showCodeInPopup == false) {
        this.vmodel1.showCodeInPopup = false;
        this.vmodel1.customerLowCodeLimit = 0;
        this.vmodel1.customerLowCodeAlertLimit = 0;
        this.vmodel1.customerCampaignDealyDays = 0;
        this.vmodel1.customerEANBarCodeText = "";
        if (
          this.vmodel1.customerStaticCode == "" ||
          this.vmodel1.customerStaticCode == null
        ) {
          this.vmodel1.customerStaticCode = "#";
        } else {
          this.vmodel1.customerStaticCode;
        }
      } else {
        this.vmodel1.customerLowCodeLimit = this.vmodel1.customerLowCodeLimitDefault;
        this.vmodel1.customerLowCodeAlertLimit = this.vmodel1.customerLowCodeAlertLimitDefault;

        if (this.vmodel1.enableAmbassadorMails == false) {
          this.vmodel1.customerCampaignDealyDays = 0;
        } else {
          this.vmodel1.customerCampaignDealyDays;
        }
      }
      // showCodeInPopup  ---WORKED
      if (this.vmodel1.showCodeInPopup == true) {
        this.vmodel1.enableDealToCustomer = true;
      }
      // enableAmbassadorMails  --Worked
      if (this.vmodel1.enableAmbassadorMails == false) {
        if (this.vmodel1.enableDealToCustomer == true) {
          this.vmodel1RewardTime = "0";
          this.vmodel1.customerCampaignDealyDays = 0;
        } else {
          this.vmodel1RewardTime = "0";
        }
      } else {
        if (this.vmodel1.enableDealToCustomer == true) {
          this.vmodel1.customerCampaignDealyDays = 0;
        }
      }

      // emailReminder

      if (this.vmodel1.emailReminder == false) {
        this.vmodel1.customerRemindBeforeDays = 0;
        this.vmodel1.customerSecondRemindBeforeDays = 0;
      } else {
        this.vmodel1.customerRemindBeforeDays = 14;
        this.vmodel1.customerSecondRemindBeforeDays = 2;
      }

      if (
        this.vmodel1.ambNeverDisplay == true &&
        this.vmodel1.openAsMinimized == false &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == false &&
        this.vmodel1.showCodeInPopup == false &&
        this.vmodel1.allowexistingmember == false &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == false &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == false &&
        this.vmodel1.emailReminder == false &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == false &&
        this.vmodel1.disablereferrals == false &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == false &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[0].text;
      } else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == true &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == true &&
        this.vmodel1.showCodeInPopup == true &&
        this.vmodel1.allowexistingmember == false &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == false &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == true &&
        this.vmodel1.emailReminder == true &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == true &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[1].text;
      } else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == true &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == false &&
        this.vmodel1.showCodeInPopup == false &&
        this.vmodel1.allowexistingmember == false &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == false &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == false &&
        this.vmodel1.emailReminder == false &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == true &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[2].text;
      } else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == false &&
        this.vmodel1.showinfomis == true &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == true &&
        this.vmodel1.showCodeInPopup == true &&
        this.vmodel1.allowexistingmember == true &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == false &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == true &&
        this.vmodel1.emailReminder == true &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == true &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[3].text;
      } else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == false &&
        this.vmodel1.showinfomis == true &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == false &&
        this.vmodel1.showCodeInPopup == false &&
        this.vmodel1.allowexistingmember == true &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == false &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == false &&
        this.vmodel1.emailReminder == false &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == true &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[4].text;
      }

      // //ONE
      else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == true &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == false &&
        this.vmodel1.showCodeInPopup == false &&
        this.vmodel1.allowexistingmember == true &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == true &&
        this.vmodel1.allowMinimizeOnLastStep == true &&
        this.vmodel1.enableAmbassadorMails == false &&
        this.vmodel1.emailReminder == false &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == false &&
        this.vmodel1.disablereferrals == true &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == false &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[5].text;
        // console.log(this.vmodel1.setloadingPreset, "hiiiiii");
      }

      // //TWO
      else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == true &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == true &&
        this.vmodel1.showCodeInPopup == true &&
        this.vmodel1.allowexistingmember == true &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == true &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == true &&
        this.vmodel1.emailReminder == true &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == false &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[6].text;
        // console.log(this.vmodel1.setloadingPreset, "hiiiiii  6");
      }

      //       //THREE
      else if (
        this.vmodel1.ambNeverDisplay == false &&
        this.vmodel1.openAsMinimized == true &&
        this.vmodel1.showinfomis == false &&
        this.vmodel1.ndmw == false &&
        this.vmodel1.enableDealToCustomer == false &&
        this.vmodel1.showCodeInPopup == false &&
        this.vmodel1.allowexistingmember == true &&
        this.vmodel1.hintButMaskCode == false &&
        this.vmodel1.allowSameReward == true &&
        this.vmodel1.allowMinimizeOnLastStep == false &&
        this.vmodel1.enableAmbassadorMails == false &&
        this.vmodel1.emailReminder == false &&
        this.vmodel1.reqEmailVer == false &&
        this.vmodel1.isCollectCPOEmailPhone == false &&
        this.vmodel1.isSendReminderAlways == true &&
        this.vmodel1.disablereferrals == false &&
        this.vmodel1.disFriendFlow == false &&
        this.vmodel1.frndlnkexp == false &&
        this.vmodel1.animateDealSetting == true &&
        this.vmodel1.enableUTMTags == false &&
        this.vmodel1InfoInFriendLink == false
      ) {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[7].text;
        // console.log(this.vmodel1.setloadingPreset);
      } else {
        this.vmodel1.setloadingPreset = this.dmodel.settings.presetList[8].text;
        // console.log(this.vmodel1.setloadingPreset);
      }
    },
    checkDomain() {
      try {
        let domain = new URL(this.vmodel.setTargetCampaignURL);
        domain = domain.hostname;
        DataLayerService.getById("/deal/validate", domain).then(result => {
          this.errorMessage = result;
        });
      } catch (error) {
        this.catchError = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.btn-change {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin-top: 32px;
}
.p-chips .p-chips-multiple-container .p-chips-input-token input {
  font-size: 1rem;
  color: #212529;
  padding: 0;
  margin: 0;
  width: 370px;
}
.btn-add {
  background-color: #791a3f;
  border-color: #791a3f;
  color: #fff;
  margin-left: 799px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  box-shadow: none;
}
.btn-add:hover {
  background-color: #791a3f;
  border-color: #791a3f;
  color: #fff;
}
.btn-danger {
  background-color: #ff6c60;
  border-color: #ff6c60;
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.4;
  border-radius: 0.2rem;
  box-shadow: none;
}
.btn-danger:hover {
  background-color: #ff6c60 !important;
  border-color: #ff6c60 !important;
}

.instruction-label {
  // padding-top: 0px;
  // padding-bottom: 3px;
  display: inline-block;
  margin-bottom: 0;
  padding-top: 7px;
  font-weight: 400;
  font-size: 0.875rem;
}
.p-calendar {
  position: relative;
  display: inline-flex;
  width: 395px;
}
input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}
// .p-dialog .p-dialog-content {
//   background: rgba(76, 184, 125, 0.08) !important;
//   color: #2d6e6d;
//   padding: 1rem;
// }
// .p-dialog .p-dialog-footer {
//   border-top: 1px solid #e9ecef;
//   background: rgba(76, 184, 125, 0.08) !important;
//   color: #212529;
//   padding: 1rem;
//   text-align: right;
//   border-bottom-right-radius: 4px;
//   border-bottom-left-radius: 4px;
//   border: none;
// }
// :deep(.browse-button) {
//   color: #ffffff;
//   background: #2d6e6d !important;
//   border-color: #2d6e6d !important;
//   padding: 0.375rem 0.75rem;
//   font-size: 1rem;
//   font-weight: 400;
//   height: 37px;
//   // opacity: 0.65;
//   text-align: center;
//   vertical-align: middle;
//   border: 1px solid transparent;
//   box-shadow: none;
//   width: 100%;
//   font-family: "Voyado Text";
// }
// .browse-button :hover {
//   background: #2d6e6d !important;
//   border-color: #2d6e6d !important;
// }
.checkbox-radio-font {
  font-size: 14px;
}
h4 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
  font-size: 1.5rem;
}
h6 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
}
:deep(.control-label) {
  font-family: "Voyado Text";
  font-weight: 400;
  font-size: 14.22px;
  padding-bottom: 3px;
  display: block;
  margin-bottom: 0px;
  padding-top: 7px;
  position: relative;
  vertical-align: top;
  line-height: 17.1px;
  color: #797971;
}
.control-label1 {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: bold;
  position: relative;
  vertical-align: top;
}
hr {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #e0dfdf;
  border-bottom: 1px solid #fefefe;
}
.square-box {
  width: 300px;
  position: relative;
  overflow: hidden;
}
.square-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
:deep(.p-chips .p-chips-multiple-container .p-chips-input-token input) {
  padding: 20px;
  margin: 0;
  padding-top: 1px;
  padding-left: inherit;
}
h5 {
  font-size: 18px;
  font-family: "Voyado Text";
  margin-bottom: 0.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.custom-settings {
  margin-top: 30px;
}
.custom-settings-button {
  font-size: 20px;
  font-weight: 400;
  line-height: 17.1px;
  text-align: left;
}
.no-border {
  color: #777777;
  border: #797971 !important;
  background: none !important;
  padding: 0;
  margin-left: 10px;
  font-size: 33px;
}

.copytooltip .tooltiptext {
  visibility: hidden;
  width: auto !important;
  background-color: #f38672;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -75px;
  opacity: 0;
  transition: opacity 0.3s;
}
.copytooltip {
  position: relative;
  display: inline-block;
  top: 0px;
  left: 10px;
}

.copytooltip .tooltiptext {
  visibility: hidden;
  width: 140px;
  background-color: #f38672;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -75px;
  opacity: 0;
  transition: opacity 0.3s;
}
.copytooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #f38672 transparent transparent transparent !important;
}
.copytooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.toggle-button {
  display: flex;
  align-items: center;
}

.header-container {
  height: 120px;
  padding: 26px 40px 26px 40px;
  gap: 0px;
  border-radius: 4px 4px 0px 0px;
  opacity: 0px;
}
.small-text {
  font-family: "Voyado Text" !important;
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
}
:deep(.card-header) {
  height: 53px;
  border-color: #eff2f7;
  background: #fff;
  font-size: 16px;
  font-weight: 500 !important;
  padding: 0.75rem 1.25rem;
  border-bottom: none;
}
.header-text {
  display: flex;
  align-items: center;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}

.header-text h5 {
  margin: 0;
}

.small-text {
  margin-left: 20px;
}
.header-text span {
  display: block;
  margin-top: 5px;
}

//New css-ry
.line-text {
  align-items: center;
  padding: 0px 42px 0px 32px !important;
}
.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}
:deep(.p-dropdown) {
  height: 40px;
  width: 395px;
  line-height: 1.5;
  font-size: 14px !important;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  color: #c0c0bc !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
  justify-content: space-between;
}

:deep(input) {
  height: 40px;
  width: 395px;
  border-radius: 4px;
  border: 1px solid #c0c0bc;
  padding: 10px;
}

:deep(.cancel-btn) {
  background-color: #fff;
  border: 2px solid #e0e9e8;
  font-weight: 500;
  color: #2d6e6d;
  height: 40px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
:deep(.cancel-btn:hover) {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.toggle-button {
  display: flex;
  align-items: center;
}
.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}
.general-settings {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.general-settings-text {
  font-size: 15px;
  font-weight: 900;
  line-height: 19.2px;
}
.toggleblock-btn {
  font-size: 15px;
  font-weight: 400;
}
.button-container {
  // height: 108px;
  padding: 26px 40px 26px 40px;
}

:deep(.text-right) {
  text-align: right !important;
}
.show-all {
  background-color: white !important;
  border: 2px solid #e0e9e8 !important;
  width: auto !important;
  padding: 0px 8px 0px 8px;
  height: 24px !important;
  border-radius: 4px !important;
  line-height: 15px !important;
  color: #2d6e6d !important;
  font-weight: 500 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}
:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}

.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}
.copytooltip i {
  font-size: 22px;
  cursor: pointer;
}
</style>
